// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: cYlS9AZba0

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import ItemDivider from "../../ItemDivider"; // plasmic-import: 0P_tUdN5Ni/component

import { ThemeValue, useTheme } from "./PlasmicGlobalVariant__Theme"; // plasmic-import: 40N_XXvhaC/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicVideoItem.module.css"; // plasmic-import: cYlS9AZba0/css

import ProgressbarIcon from "./icons/PlasmicIcon__Progressbar"; // plasmic-import: OlLsdl8YS4/icon
import YoutubeShortssvgIcon from "./icons/PlasmicIcon__YoutubeShortssvg"; // plasmic-import: wIccPr0oyxLE/icon

createPlasmicElementProxy;

export type PlasmicVideoItem__VariantMembers = {
  awaitingMetadata: "awaitingMetadata";
  displayMode: "grid" | "list";
  isShort: "isShort";
};
export type PlasmicVideoItem__VariantsArgs = {
  awaitingMetadata?: SingleBooleanChoiceArg<"awaitingMetadata">;
  displayMode?: SingleChoiceArg<"grid" | "list">;
  isShort?: SingleBooleanChoiceArg<"isShort">;
};
type VariantPropType = keyof PlasmicVideoItem__VariantsArgs;
export const PlasmicVideoItem__VariantProps = new Array<VariantPropType>(
  "awaitingMetadata",
  "displayMode",
  "isShort"
);

export type PlasmicVideoItem__ArgsType = {
  title?: React.ReactNode;
  channel?: React.ReactNode;
  metaData?: React.ReactNode;
  duration?: React.ReactNode;
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicVideoItem__ArgsType;
export const PlasmicVideoItem__ArgProps = new Array<ArgPropType>(
  "title",
  "channel",
  "metaData",
  "duration",
  "children"
);

export type PlasmicVideoItem__OverridesType = {
  card?: p.Flex<"div">;
  videoThumbnailContainer?: p.Flex<"div">;
  image?: p.Flex<typeof p.PlasmicImg>;
  videoLengthContainer?: p.Flex<"div">;
  videoData?: p.Flex<"div">;
  videoTitle?: p.Flex<"div">;
  videoMetaData?: p.Flex<"div">;
  meta?: p.Flex<"div">;
  channelData?: p.Flex<"div">;
  itemDivider?: p.Flex<typeof ItemDivider>;
};

export interface DefaultVideoItemProps {
  title?: React.ReactNode;
  channel?: React.ReactNode;
  metaData?: React.ReactNode;
  duration?: React.ReactNode;
  children?: React.ReactNode;
  awaitingMetadata?: SingleBooleanChoiceArg<"awaitingMetadata">;
  displayMode?: SingleChoiceArg<"grid" | "list">;
  isShort?: SingleBooleanChoiceArg<"isShort">;
  className?: string;
}

const $$ = {};

function PlasmicVideoItem__RenderFunc(props: {
  variants: PlasmicVideoItem__VariantsArgs;
  args: PlasmicVideoItem__ArgsType;
  overrides: PlasmicVideoItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "awaitingMetadata",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          $props.awaitingMetadata
      },
      {
        path: "displayMode",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.displayMode
      },
      {
        path: "isShort",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.isShort
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const globalVariants = ensureGlobalVariants({
    theme: useTheme()
  });

  return (
    <p.Stack
      as={"div"}
      data-plasmic-name={"card"}
      data-plasmic-override={overrides.card}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.card,
        {
          [projectcss.global_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.cardawaitingMetadata]: hasVariant(
            $state,
            "awaitingMetadata",
            "awaitingMetadata"
          ),
          [sty.carddisplayMode_list]: hasVariant($state, "displayMode", "list"),
          [sty.cardglobal_theme_dark_displayMode_list]:
            hasVariant($state, "displayMode", "list") &&
            hasVariant(globalVariants, "theme", "dark"),
          [sty.cardisShort]: hasVariant($state, "isShort", "isShort")
        }
      )}
    >
      <div
        data-plasmic-name={"videoThumbnailContainer"}
        data-plasmic-override={overrides.videoThumbnailContainer}
        className={classNames(projectcss.all, sty.videoThumbnailContainer, {
          [sty.videoThumbnailContainerawaitingMetadata]: hasVariant(
            $state,
            "awaitingMetadata",
            "awaitingMetadata"
          ),
          [sty.videoThumbnailContainerdisplayMode_list]: hasVariant(
            $state,
            "displayMode",
            "list"
          ),
          [sty.videoThumbnailContainerglobal_theme_dark]: hasVariant(
            globalVariants,
            "theme",
            "dark"
          ),
          [sty.videoThumbnailContainerisShort]: hasVariant(
            $state,
            "isShort",
            "isShort"
          )
        })}
      >
        <p.PlasmicImg
          data-plasmic-name={"image"}
          data-plasmic-override={overrides.image}
          alt={""}
          className={classNames(sty.image, {
            [sty.imageawaitingMetadata]: hasVariant(
              $state,
              "awaitingMetadata",
              "awaitingMetadata"
            ),
            [sty.imagedisplayMode_grid]: hasVariant(
              $state,
              "displayMode",
              "grid"
            ),
            [sty.imagedisplayMode_list]: hasVariant(
              $state,
              "displayMode",
              "list"
            ),
            [sty.imageglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.imageisShort]: hasVariant($state, "isShort", "isShort")
          })}
          displayHeight={"100%"}
          displayMaxHeight={"none"}
          displayMaxWidth={"none"}
          displayMinHeight={"0"}
          displayMinWidth={"0"}
          displayWidth={"100%"}
          id={"thumbnail"}
          loader={"plasmic"}
          src={{
            src: "https://img.plasmic.app/img-optimizer/v1/img/6557e7f0c72a34b8f7b52445b06ff7ef.jpg",
            fullWidth: 319,
            fullHeight: 480
          }}
        />

        {false ? (
          <div className={classNames(projectcss.all, sty.freeBox__io041)}>
            <ProgressbarIcon
              className={classNames(projectcss.all, sty.svg__s8Zj)}
              role={"img"}
            />
          </div>
        ) : null}
        {(
          hasVariant($state, "awaitingMetadata", "awaitingMetadata")
            ? false
            : true
        ) ? (
          <p.Stack
            as={"div"}
            data-plasmic-name={"videoLengthContainer"}
            data-plasmic-override={overrides.videoLengthContainer}
            hasGap={true}
            className={classNames(projectcss.all, sty.videoLengthContainer, {
              [sty.videoLengthContainerawaitingMetadata]: hasVariant(
                $state,
                "awaitingMetadata",
                "awaitingMetadata"
              ),
              [sty.videoLengthContainerdisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              ),
              [sty.videoLengthContainerisShort]: hasVariant(
                $state,
                "isShort",
                "isShort"
              )
            })}
          >
            <div className={classNames(projectcss.all, sty.freeBox__mzbW)}>
              {p.renderPlasmicSlot({
                defaultContents: "11:11",
                value: args.duration,
                className: classNames(sty.slotTargetDuration, {
                  [sty.slotTargetDurationdisplayMode_list]: hasVariant(
                    $state,
                    "displayMode",
                    "list"
                  )
                })
              })}
            </div>
          </p.Stack>
        ) : null}
        <div
          className={classNames(projectcss.all, sty.freeBox__inEcc, {
            [sty.freeBoxisShort__inEcceZo2S]: hasVariant(
              $state,
              "isShort",
              "isShort"
            )
          })}
        >
          <YoutubeShortssvgIcon
            className={classNames(projectcss.all, sty.svg__ncSqg, {
              [sty.svgisShort__ncSqgeZo2S]: hasVariant(
                $state,
                "isShort",
                "isShort"
              )
            })}
            role={"img"}
          />
        </div>
      </div>
      <p.Stack
        as={"div"}
        data-plasmic-name={"videoData"}
        data-plasmic-override={overrides.videoData}
        hasGap={true}
        className={classNames(projectcss.all, sty.videoData, {
          [sty.videoDataawaitingMetadata]: hasVariant(
            $state,
            "awaitingMetadata",
            "awaitingMetadata"
          ),
          [sty.videoDatadisplayMode_list]: hasVariant(
            $state,
            "displayMode",
            "list"
          ),
          [sty.videoDataglobal_theme_dark_displayMode_list]:
            hasVariant($state, "displayMode", "list") &&
            hasVariant(globalVariants, "theme", "dark")
        })}
      >
        <div
          data-plasmic-name={"videoTitle"}
          data-plasmic-override={overrides.videoTitle}
          className={classNames(projectcss.all, sty.videoTitle, {
            [sty.videoTitleawaitingMetadata]: hasVariant(
              $state,
              "awaitingMetadata",
              "awaitingMetadata"
            ),
            [sty.videoTitledisplayMode_list]: hasVariant(
              $state,
              "displayMode",
              "list"
            ),
            [sty.videoTitleglobal_theme_dark]: hasVariant(
              globalVariants,
              "theme",
              "dark"
            ),
            [sty.videoTitleglobal_theme_dark_displayMode_list]:
              hasVariant($state, "displayMode", "list") &&
              hasVariant(globalVariants, "theme", "dark")
          })}
        >
          {p.renderPlasmicSlot({
            defaultContents: "Readheads are an endangered spiecies in...",
            value: args.title,
            className: classNames(sty.slotTargetTitle, {
              [sty.slotTargetTitleawaitingMetadata]: hasVariant(
                $state,
                "awaitingMetadata",
                "awaitingMetadata"
              ),
              [sty.slotTargetTitledisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              ),
              [sty.slotTargetTitleglobal_theme_dark]: hasVariant(
                globalVariants,
                "theme",
                "dark"
              ),
              [sty.slotTargetTitleglobal_theme_dark_displayMode_list]:
                hasVariant($state, "displayMode", "list") &&
                hasVariant(globalVariants, "theme", "dark"),
              [sty.slotTargetTitleglobal_theme_light]: hasVariant(
                globalVariants,
                "theme",
                "light"
              )
            })
          })}
        </div>
        <p.Stack
          as={"div"}
          data-plasmic-name={"videoMetaData"}
          data-plasmic-override={overrides.videoMetaData}
          hasGap={true}
          className={classNames(projectcss.all, sty.videoMetaData, {
            [sty.videoMetaDataawaitingMetadata]: hasVariant(
              $state,
              "awaitingMetadata",
              "awaitingMetadata"
            ),
            [sty.videoMetaDatadisplayMode_list]: hasVariant(
              $state,
              "displayMode",
              "list"
            )
          })}
        >
          <div
            data-plasmic-name={"meta"}
            data-plasmic-override={overrides.meta}
            className={classNames(projectcss.all, sty.meta, {
              [sty.metadisplayMode_list]: hasVariant(
                $state,
                "displayMode",
                "list"
              )
            })}
          >
            <div
              data-plasmic-name={"channelData"}
              data-plasmic-override={overrides.channelData}
              className={classNames(projectcss.all, sty.channelData, {
                [sty.channelDatadisplayMode_list]: hasVariant(
                  $state,
                  "displayMode",
                  "list"
                ),
                [sty.channelDataglobal_theme_dark_displayMode_list]:
                  hasVariant($state, "displayMode", "list") &&
                  hasVariant(globalVariants, "theme", "dark")
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__oOyhq
                    )}
                  >
                    {"BestChannel"}
                  </div>
                ),
                value: args.channel,
                className: classNames(sty.slotTargetChannel, {
                  [sty.slotTargetChannelawaitingMetadata]: hasVariant(
                    $state,
                    "awaitingMetadata",
                    "awaitingMetadata"
                  ),
                  [sty.slotTargetChanneldisplayMode_list]: hasVariant(
                    $state,
                    "displayMode",
                    "list"
                  ),
                  [sty.slotTargetChannelglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.slotTargetChannelglobal_theme_dark_displayMode_list]:
                    hasVariant($state, "displayMode", "list") &&
                    hasVariant(globalVariants, "theme", "dark")
                })
              })}
            </div>
            <div
              className={classNames(projectcss.all, sty.freeBox__oZqy7, {
                [sty.freeBoxdisplayMode_list__oZqy7Y705]: hasVariant(
                  $state,
                  "displayMode",
                  "list"
                ),
                [sty.freeBoxglobal_theme_dark_displayMode_list__oZqy7OIz4XY705]:
                  hasVariant($state, "displayMode", "list") &&
                  hasVariant(globalVariants, "theme", "dark")
              })}
            >
              {p.renderPlasmicSlot({
                defaultContents: "20K views  -  2 weeks ago",
                value: args.metaData,
                className: classNames(sty.slotTargetMetaData, {
                  [sty.slotTargetMetaDataawaitingMetadata]: hasVariant(
                    $state,
                    "awaitingMetadata",
                    "awaitingMetadata"
                  ),
                  [sty.slotTargetMetaDatadisplayMode_list]: hasVariant(
                    $state,
                    "displayMode",
                    "list"
                  ),
                  [sty.slotTargetMetaDataglobal_theme_dark]: hasVariant(
                    globalVariants,
                    "theme",
                    "dark"
                  ),
                  [sty.slotTargetMetaDataglobal_theme_dark_displayMode_list]:
                    hasVariant($state, "displayMode", "list") &&
                    hasVariant(globalVariants, "theme", "dark")
                })
              })}
            </div>
          </div>
          <div
            className={classNames(projectcss.all, sty.freeBox___7SvqU, {
              [sty.freeBoxdisplayMode_list___7SvqUy705]: hasVariant(
                $state,
                "displayMode",
                "list"
              )
            })}
          >
            {p.renderPlasmicSlot({
              defaultContents:
                "Bacon ipsum dolor amet jerky brisket kielbasa pork chop, spare ribs filet mignon pastrami bacon pancetta pig ham. Leberkas sirloin andouille bacon shankle ball tip doner pig. Short loin burgdoggen flank jerky strip steak pancetta chicken sausage tongue ball tip. Ground round ham pork belly chuck",
              value: args.children,
              className: classNames(sty.slotTargetChildren, {
                [sty.slotTargetChildrendisplayMode_list]: hasVariant(
                  $state,
                  "displayMode",
                  "list"
                ),
                [sty.slotTargetChildrenglobal_theme_dark_displayMode_list]:
                  hasVariant($state, "displayMode", "list") &&
                  hasVariant(globalVariants, "theme", "dark")
              })
            })}
          </div>
        </p.Stack>
      </p.Stack>
      <ItemDivider
        data-plasmic-name={"itemDivider"}
        data-plasmic-override={overrides.itemDivider}
        className={classNames("__wab_instance", sty.itemDivider, {
          [sty.itemDividerdisplayMode_list]: hasVariant(
            $state,
            "displayMode",
            "list"
          ),
          [sty.itemDividerglobal_theme_dark_displayMode_list]:
            hasVariant($state, "displayMode", "list") &&
            hasVariant(globalVariants, "theme", "dark")
        })}
      />
    </p.Stack>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  card: [
    "card",
    "videoThumbnailContainer",
    "image",
    "videoLengthContainer",
    "videoData",
    "videoTitle",
    "videoMetaData",
    "meta",
    "channelData",
    "itemDivider"
  ],
  videoThumbnailContainer: [
    "videoThumbnailContainer",
    "image",
    "videoLengthContainer"
  ],
  image: ["image"],
  videoLengthContainer: ["videoLengthContainer"],
  videoData: [
    "videoData",
    "videoTitle",
    "videoMetaData",
    "meta",
    "channelData"
  ],
  videoTitle: ["videoTitle"],
  videoMetaData: ["videoMetaData", "meta", "channelData"],
  meta: ["meta", "channelData"],
  channelData: ["channelData"],
  itemDivider: ["itemDivider"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  card: "div";
  videoThumbnailContainer: "div";
  image: typeof p.PlasmicImg;
  videoLengthContainer: "div";
  videoData: "div";
  videoTitle: "div";
  videoMetaData: "div";
  meta: "div";
  channelData: "div";
  itemDivider: typeof ItemDivider;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicVideoItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicVideoItem__VariantsArgs;
    args?: PlasmicVideoItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicVideoItem__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicVideoItem__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicVideoItem__ArgProps,
          internalVariantPropNames: PlasmicVideoItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicVideoItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "card") {
    func.displayName = "PlasmicVideoItem";
  } else {
    func.displayName = `PlasmicVideoItem.${nodeName}`;
  }
  return func;
}

export const PlasmicVideoItem = Object.assign(
  // Top-level PlasmicVideoItem renders the root element
  makeNodeComponent("card"),
  {
    // Helper components rendering sub-elements
    videoThumbnailContainer: makeNodeComponent("videoThumbnailContainer"),
    image: makeNodeComponent("image"),
    videoLengthContainer: makeNodeComponent("videoLengthContainer"),
    videoData: makeNodeComponent("videoData"),
    videoTitle: makeNodeComponent("videoTitle"),
    videoMetaData: makeNodeComponent("videoMetaData"),
    meta: makeNodeComponent("meta"),
    channelData: makeNodeComponent("channelData"),
    itemDivider: makeNodeComponent("itemDivider"),

    // Metadata about props expected for PlasmicVideoItem
    internalVariantProps: PlasmicVideoItem__VariantProps,
    internalArgProps: PlasmicVideoItem__ArgProps
  }
);

export default PlasmicVideoItem;
/* prettier-ignore-end */
